import { useMutation } from '@tanstack/react-query';
import {
  downloadFileSFTP,
  uploadToSFTP,
  deleteTrainingFiles,
} from '@/api/sftp/file';
import { getFileProcessed } from '@/api/ai_model/ai_model';
import { FileData } from '@/api/entities/engineCorrection';
import { TCustomQueryProps } from '@/type/hooks.types';

export const useDownloadFileSFTP = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: (fileName: string) => downloadFileSFTP(fileName),
    onSuccess: (data) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const url = window.URL.createObjectURL(new Blob([data as any]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'filename.mp4'); // Set the file name here
      document.body.appendChild(link);
      link.click();
      link.remove();
      onSuccess();
    },
    onError: (error) => {
      console.error('API call failed with error:', error);
    },
  });
};

export const useGetFileProcessed = () => {
  return useMutation({
    mutationFn: (fileName: string) => getFileProcessed(fileName),
    onSuccess: (data) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const url = window.URL.createObjectURL(new Blob([data as any]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'processed_video-2.mp4');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    },
    onError: (error) => {
      console.error('API call failed with error:', error);
    },
  });
};

export const usePostFileSFTP = ({
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  return useMutation({
    mutationFn: ({ fileData }: { fileData: FileData }) =>
      uploadToSFTP(fileData),
    onSuccess: () => {
      handleSuccess?.();
    },
    onError: (error) => {
      console.error('API call failed with error:', error);
    },
  });
};

export const useDeleteTrainingFiles = ({
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  return useMutation({
    mutationFn: (fileName: string) => deleteTrainingFiles(fileName),
    onSuccess: () => {
      handleSuccess?.();
    },
    onError: (error) => {
      console.error('Error deleting training files from R2:', error);
    },
  });
};
